import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { Params, RouterLink } from '@angular/router'
import { IconComponent } from '../icon'

@Component({
  standalone: true,
  selector: 'ftr-link',
  templateUrl: './link.component.html',
  imports: [IconComponent, RouterLink, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @Input()
  routerLinkInput: string[] | undefined

  @Input()
  href: string | undefined

  @Output()
  openLink = new EventEmitter<void>()

  @Input()
  openInNewTab = true

  @Input()
  queryParamsInput: Params | undefined

  get getRouterLink(): any {
    return this.routerLinkInput ? this.routerLinkInput : undefined
  }

  get getOpenInNewTab(): any {
    return this.openInNewTab ? '_blank' : undefined
  }

  get getQueryParams(): any {
    return this.queryParamsInput || undefined
  }
}
